<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks';

    export default {
        components: {
            AppTabLinks,
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'Карточка',
                        url: `/surveys/${this.$route.params.id}/questions/${this.$route.params.question_id}`,
                    },
                    {
                        title: 'Редактировать',
                        url: `/surveys/${this.$route.params.id}/questions/${this.$route.params.question_id}/edit`,
                    },
                ],
            };
        },
    };
</script>
